export const SUPERVISOR_ADMINISTRATION_TEXT = {
  administrationTitlePrefix: 'Адміністрування',
  searchPlaceholder: 'Пошук за напрямом або email',
  emptyTitle: 'Секції не знайдено',
  emptyDescription: 'Після появи секцій вони будуть доступні для налаштування на цій сторінці.',
  emptySupervisors: 'Список порожній',
  addUserLabel: 'Додати користувача',
  addUserPlaceholder: 'user@eximb.com',
  guaranteesSectionTitle: 'Гарантії',
  guaranteesSectionSubtitle:
    'Керуйте користувачами, які відповідають за гарантійний напрям.',
  guaranteesResponsibleTitle: 'Відповідальний за гарантії',
  guaranteesControllerTitle: 'Контролер гарантій',
  guaranteesRolePrefix: 'Напрям',
  guaranteesUsersCountPrefix: 'Користувачів',
  usapokPageTitleSuffix: 'УСАПОК',
  umvnPageTitleSuffix: 'УМВН',
  uoPageTitleSuffix: 'ЮО',
  udbtfPageTitleSuffix: 'УДБТФ',
  administrationStubSubtitle:
    'Керуйте користувачами, які відповідають за гарантійний напрям.',
} as const;

export const SUPERVISOR_ADMINISTRATION_SECTION_IDS = {
  responsible: 'guarantees-responsible',
  controller: 'guarantees-controller',
  usapokResponsible: 'usapok-guarantees-responsible',
  umvnResponsible: 'umvn-guarantees-responsible',
  uoResponsible: 'uo-guarantees-responsible',
  udbtfResponsible: 'udbtf-guarantees-responsible',
} as const;

export const SUPERVISOR_ADMINISTRATION_ARIA = {
  searchButton: 'Запустити пошук секцій',
  clearSearchButton: 'Очистити пошук секцій',
} as const;

export const SUPERVISOR_ADMINISTRATION_ERRORS = {
  invalidEmail: 'Вкажіть email у форматі user@eximb.com',
  duplicateEmail: 'Цей email вже додано до цієї секції',
} as const;

export const SUPERVISOR_ADMINISTRATION_EMAIL_PATTERN = /^[^\s@]+@eximb\.com$/i;

